export const filterBarStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '16px',
  padding: '16px 0 16px 0',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  marginBottom: '16px',
};

export const searchWrapperStyles = {
  flex: '0 0 50%',
  maxWidth: '50%',
};

export const authorFilterWrapperStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  justifyContent: 'flex-end',
};
